export interface ColorPicker {
    colorId: string | null;
    backgroundColor: string;
    strokeColor: string;
    isDefaultColor?: boolean;
}

export enum Color {
    blue = 1,
    green = 2,
    pink = 3,
    graniteGray = 4,
    lightBlue = 5,
    yellow = 6,
    teal = 7,
    darkBlue = 8,
    red = 9,
    lightGreen = 10,
    purple = 11,
    skyBlue = 12,
    lavender = 13,
    rose = 14,
    mintGreen = 15,
    gold = 16,
    blush = 17,
    greenCyan = 18,
    cyanBlue = 19,
}

export const colors: Array<ColorPicker> = [
    { colorId: Color.blue.toString(), backgroundColor: "#E3F3FD", strokeColor: "#183683" },
    { colorId: Color.green.toString(), backgroundColor: "#B2EAE4", strokeColor: "#0D4B45" },
    { colorId: Color.pink.toString(), backgroundColor: "#F7E7F2", strokeColor: "#D54678" },
    { colorId: Color.graniteGray.toString(), backgroundColor: "#E7E7EC", strokeColor: "#676767" },
    { colorId: Color.lightBlue.toString(), backgroundColor: "#E6E5FC", strokeColor: "#618CF5", isDefaultColor: true },
    { colorId: Color.yellow.toString(), backgroundColor: "#FAF5BC", strokeColor: "#FF8000" },
    { colorId: Color.teal.toString(), backgroundColor: "#D2E3FC", strokeColor: "#1358BE" },
    { colorId: Color.darkBlue.toString(), backgroundColor: "#B7CAF8", strokeColor: "#183683" },
    { colorId: Color.red.toString(), backgroundColor: "#F7E2DE", strokeColor: "#E02700" },
    { colorId: Color.lightGreen.toString(), backgroundColor: "#F0FCF7", strokeColor: "#27A36E" },
    { colorId: Color.purple.toString(), backgroundColor: "#F4D9F8", strokeColor: "#7F4288" },
    { colorId: Color.skyBlue.toString(), backgroundColor: "#D6EFFE", strokeColor: "#2FB0FD" },
    { colorId: Color.lavender.toString(), backgroundColor: "#EDE2FE", strokeColor: "#AC7EF4" },
    { colorId: Color.rose.toString(), backgroundColor: "#FFDAF7", strokeColor: "#FA78DE" },
    { colorId: Color.mintGreen.toString(), backgroundColor: "#D0F7C3", strokeColor: "#6EA35C" },
    { colorId: Color.gold.toString(), backgroundColor: "#FFEBB6", strokeColor: "#BE8A00" },
    { colorId: Color.blush.toString(), backgroundColor: "#F7BBC9", strokeColor: "#D55F7B" },
    { colorId: Color.greenCyan.toString(), backgroundColor: "#C2F5E9", strokeColor: "#53A08E" },
    { colorId: Color.cyanBlue.toString(), backgroundColor: "#E5EEFD", strokeColor: "#377CF7" },
];

export function GetColorPicker(colorId?: string, customColors?: Array<ColorPicker>): ColorPicker {
    const fallbackColor: ColorPicker = colors.find((x) => x.isDefaultColor) ?? {
        colorId: null,
        backgroundColor: "#B0BCC6",
        strokeColor: "#000000",
        isDefaultColor: true,
    };

    if (customColors) {
        if (colorId) {
            return customColors.find((x) => x.colorId === colorId) ?? fallbackColor;
        }
        return customColors.find((x) => x.isDefaultColor) ?? fallbackColor;
    }

    return colors.find((x) => x.colorId === colorId) ?? fallbackColor;
}
